import SubjectContent from '../shared/SubjectContent';
import { finalDesign } from './finalDesign';

export default function EnglishContent() {
    return <SubjectContent page="en" design={finalDesign} />;
}
